module.exports = __webpack_public_path__ + "img/palmar-pool-3.d1556627.jpg";